const modalAddressElms = {
  modal: document.querySelector(".location"),
  close: document.querySelector(
    ".location .container-modal-alert .close-modal"
  ),
  overlay: document.querySelector(".modal-overlay"),
};

const openModalAddress = () => {
  modalAddressElms.modal.classList.add("open");
  modalAddressElms.overlay.classList.add("open");
};

const closeModalAddress = () => {
  modalAddressElms.modal.classList.remove("open");
  modalAddressElms.overlay.classList.remove("open");
};

// Event listeners
window.addEventListener("is-open-modal-location", (e) => {
  if (e?.detail?.firstOpen === "first")
    modalAddressElms?.close?.classList?.add("hidden");
  if (!e?.detail?.open) return closeModalAddress();
  openModalAddress();
});

modalAddressElms.close?.addEventListener("click", closeModalAddress);
